<div class="overlay" *ngIf="!comming_soon" >
    <div class="container" (click)="play()" title="Entzun" alt="Entzun">
      <ng-container *ngIf="!comming_soon">
      <h1 [ngClass]="{'start':startApp}">brba</h1>
      <div class="logoImage">
        <img src="https://brba.audio-lab.org/files/2020/03/logo.png">
      </div>
      <div *ngIf="false" class="pulse"></div>
      <h1 [ngClass]="{'start':startApp}">audio galeria</h1>
      </ng-container>
      <!-- <h3 *ngIf="comming_soon" class="comming">Comming soon</h3> -->
    </div>
    <h1>{{icy_metadata}}</h1>
</div>
